/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Seller1Inputs */

const id_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

const ms_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penjual`)
};

const da_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sælger`)
};

const de_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkäufer`)
};

const en_us2_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seller`)
};

const es_es2_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const es_mx2_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const fil_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagbebenta`)
};

const fr_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendeur`)
};

const it_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venditore`)
};

const hu_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eladó`)
};

const nl_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkoper`)
};

const no_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selger`)
};

const pl_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprzedawca`)
};

const pt_br2_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const pt_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendedor`)
};

const ro_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vânzător`)
};

const fi_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myyjä`)
};

const sv_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Säljare`)
};

const vi_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người bán`)
};

const tr_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satıcı`)
};

const cs_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodejce`)
};

const bg_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавач`)
};

const ru_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавец`)
};

const uk_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продавець`)
};

const ar_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البائع`)
};

const hi_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विक्रेता`)
};

const th_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้ขาย`)
};

const ja_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`販売元`)
};

const zh_cn2_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`销售商`)
};

const zh_hant1_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`銷售商`)
};

const ko_offerdetail_table_seller1 = /** @type {(inputs: Offerdetail_Table_Seller1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`판매자`)
};

/**
* | output |
* | --- |
* | "Seller" |
*
* @param {Offerdetail_Table_Seller1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_seller1 = /** @type {((inputs?: Offerdetail_Table_Seller1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Seller1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_seller1(inputs)
	if (locale === "ms") return ms_offerdetail_table_seller1(inputs)
	if (locale === "da") return da_offerdetail_table_seller1(inputs)
	if (locale === "de") return de_offerdetail_table_seller1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_seller1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_seller1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_seller1(inputs)
	if (locale === "fil") return fil_offerdetail_table_seller1(inputs)
	if (locale === "fr") return fr_offerdetail_table_seller1(inputs)
	if (locale === "it") return it_offerdetail_table_seller1(inputs)
	if (locale === "hu") return hu_offerdetail_table_seller1(inputs)
	if (locale === "nl") return nl_offerdetail_table_seller1(inputs)
	if (locale === "no") return no_offerdetail_table_seller1(inputs)
	if (locale === "pl") return pl_offerdetail_table_seller1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_seller1(inputs)
	if (locale === "pt") return pt_offerdetail_table_seller1(inputs)
	if (locale === "ro") return ro_offerdetail_table_seller1(inputs)
	if (locale === "fi") return fi_offerdetail_table_seller1(inputs)
	if (locale === "sv") return sv_offerdetail_table_seller1(inputs)
	if (locale === "vi") return vi_offerdetail_table_seller1(inputs)
	if (locale === "tr") return tr_offerdetail_table_seller1(inputs)
	if (locale === "cs") return cs_offerdetail_table_seller1(inputs)
	if (locale === "bg") return bg_offerdetail_table_seller1(inputs)
	if (locale === "ru") return ru_offerdetail_table_seller1(inputs)
	if (locale === "uk") return uk_offerdetail_table_seller1(inputs)
	if (locale === "ar") return ar_offerdetail_table_seller1(inputs)
	if (locale === "hi") return hi_offerdetail_table_seller1(inputs)
	if (locale === "th") return th_offerdetail_table_seller1(inputs)
	if (locale === "ja") return ja_offerdetail_table_seller1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_seller1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_seller1(inputs)
	return ko_offerdetail_table_seller1(inputs)
});
export { offerdetail_table_seller1 as "offerDetail.table.seller" }